import { render, staticRenderFns } from "./guard_config_list.vue?vue&type=template&id=532602f6"
import script from "./guard_config_list.vue?vue&type=script&lang=js"
export * from "./guard_config_list.vue?vue&type=script&lang=js"
import style0 from "./guard_config_list.vue?vue&type=style&index=0&id=532602f6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532602f6')) {
      api.createRecord('532602f6', component.options)
    } else {
      api.reload('532602f6', component.options)
    }
    module.hot.accept("./guard_config_list.vue?vue&type=template&id=532602f6", function () {
      api.rerender('532602f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/config/guard_config_list.vue"
export default component.exports